import { gql } from '__generated__';

export default gql(`
  mutation AddDiscount($input: AddDiscountInput!) {
    addDiscount(input: $input) {
      id
    }
  }
`);
